import { CUSTOM_FONTS } from "helpers/editorFonts";

// Branding fonts are limited to what the editors already offer.
export const BRANDING_FONTS = [
  { name: "Open Sans", fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif" },
  ...CUSTOM_FONTS.map(({ name, fontFamily }) => ({ name, fontFamily })),
];

export const getFontFamily = (name) =>
  (BRANDING_FONTS.find(f => f.name === name) || BRANDING_FONTS[0]).fontFamily;
